import React from 'react';
import { CountryFlag } from 'project/country-flag';
import { getPlayerExternalLink } from 'components/live-player';
import { sortAscAZ } from 'components/leaderboard';
import livePlayer from '../../live-player/js/live-player';
import { LEADERBOARD_WIDGET_SCORECARD_TITLE } from '../../live-player/js/enums';

class LeaderboardWidgetAlphaList extends React.Component {
    renderRow(player) {
        const { options } = this.props;
        let targetUrl = null;

        if (options.targetsConfig) {
            targetUrl = getPlayerExternalLink(options.targetsConfig.url, player.playerId);
        }

        const showPlayer = () => {
            if (!targetUrl) {
                livePlayer.show(player.playerId, LEADERBOARD_WIDGET_SCORECARD_TITLE + player.firstName + ' ' + player.lastName);
            }
        };

        return (
            <a
                className="leaderboard-widget__row leaderboard-widget__row--alpha"
                href={targetUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={showPlayer}
                key={player.playerId}
            >
                <div className="leaderboard-widget__cell is-name">
                    <div className="leaderboard-widget__name-content">
                        <CountryFlag
                            childCss={'leaderboard-widget__country-flag'}
                            image={player.countryFlagSrc}
                            title={player.country}
                        />
                        <div className="leaderboard-widget__name-content-last-name">{player.lastName},</div>
                        <div className="leaderboard-widget__name-content-first-name">{player.firstName}</div>
                    </div>
                </div>
            </a>
        );
    }

    render() {
        const { players } = this.props;

        if (!Array.isArray(players)) return null;

        const sortedPlayers = sortAscAZ(players, 'lastName');

        return (
            <div>
                {sortedPlayers.slice(0, 10).map((player) => this.renderRow(player))}
            </div>
        );
    }
}

export default LeaderboardWidgetAlphaList;
